
import React from 'react';
import { Loader2, ArrowRight, Check } from 'lucide-react';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { featuresAnnual } from '../PlanFeatures';

interface AnnualPlanProps {
  isProcessing: string | null;
  onSelectPlan: (plan: 'annual') => void;
  popular?: boolean;
}

const AnnualPlan: React.FC<AnnualPlanProps> = ({ 
  isProcessing, 
  onSelectPlan,
  popular = false 
}) => {
  return (
    <Card className={`border border-border/50 bg-card/30 backdrop-blur-sm hover:border-border/80 transition-all duration-300 overflow-hidden relative ${popular ? 'scale-105 shadow-lg shadow-primary/5 border-primary/20 z-10' : ''}`}>
      {popular && (
        <div className="absolute top-0 left-0 right-0 flex justify-center">
          <Badge variant="default" className="bg-[#0b5d29] text-primary-foreground rounded-t-none rounded-b-md px-3 py-1 text-xs">
            MOST POPULAR
          </Badge>
        </div>
      )}
      <div className="absolute top-0 right-0 p-2">
        <Badge variant="secondary" className="bg-muted/50 text-xs font-medium">
          SAVE 65%
        </Badge>
      </div>
      <div className="p-6 space-y-2">
        <h3 className="text-2xl font-bold">Annual</h3>
        <div className="flex items-end gap-2">
          <span className="text-4xl font-bold">$79</span>
          <span className="text-muted-foreground">/year</span>
        </div>
        <p className="text-sm text-muted-foreground">
          <span className="line-through text-muted-foreground mr-1">$228</span>
          <span className="text-primary">$149 savings</span>
        </p>
        <p className="text-sm text-muted-foreground">14-day free trial, then $79/year</p>
      </div>
      <Separator className="bg-border/20" />
      <CardContent className="pt-6">
        <ul className="space-y-3">
          {featuresAnnual.map((feature, index) => (
            <li key={index} className="flex items-start">
              <Check size={18} className="min-w-4 text-green-500 mr-2 mt-0.5" />
              <span className="text-sm">{feature}</span>
            </li>
          ))}
        </ul>
      </CardContent>
      <CardFooter className="flex flex-col space-y-3 pt-0 px-6 pb-6">
        <Button 
          className="w-full group" 
          onClick={() => onSelectPlan('annual')}
          disabled={isProcessing !== null}
        >
          {isProcessing === 'annual' ? (
            <>
              <Loader2 size={16} className="mr-2 animate-spin" />
              Processing...
            </>
          ) : (
            <>
              Start My FREE Trial
              <ArrowRight size={16} className="ml-2 transition-transform group-hover:translate-x-1" />
            </>
          )}
        </Button>
      </CardFooter>
    </Card>
  );
};

export default AnnualPlan;
